import {prefixPath} from "@pg-mono/prefix-path";

import {USER_API_PREFIX} from "./api_prefixes";

const apiPath = prefixPath(USER_API_PREFIX, {
    oauth: prefixPath("oauth/", {
        authorize: "authorize/",
        token: "token/"
    }),
    proxy: prefixPath("proxy/", {
        favorites: prefixPath("favorites/", {
            favorite: "favorite/"
        }),
        login: "login/",
        unsubscribe: prefixPath("unsubscribe/", {
            mailing: prefixPath("mailing/", {
                getLink: "get-link/"
            })
        }),
        user: prefixPath("user/", {
            info: "info/",
            preferences: "preferences/",
            sendPhoneVerificationCode: "get-phone-verification-code/",
            verifyPhone: "verify-phone/"
        }),
        thirdPartyLogin: "third-party-login/",
        validators: prefixPath("validators/", {
            email: "verify-email/"
        })
    }),
    users: prefixPath("users/", {
        info: "info/",
        logout: "logout/"
    }),
    session: prefixPath("session/", {
        sync: "sync/"
    })
});

export const apiUserLink = {
    favorites: {
        favorite: apiPath.proxy.favorites.favorite
    },
    login: apiPath.proxy.login,
    oauth: {
        authorize: apiPath.oauth.authorize,
        token: apiPath.oauth.token
    },
    unsubscribe: {
        getLink: apiPath.proxy.unsubscribe.mailing.getLink
    },
    user: {
        info: apiPath.proxy.user.info,
        preferences: apiPath.proxy.user.preferences,
        sendPhoneVerificationCode: apiPath.proxy.user.sendPhoneVerificationCode,
        verifyPhone: apiPath.proxy.user.verifyPhone
    },
    users: {
        info: apiPath.users.info,
        logout: apiPath.users.logout
    },
    session: {
        sync: apiPath.session.sync
    },
    thirdPartyLogin: apiPath.proxy.thirdPartyLogin,
    validators: {
        email: apiPath.proxy.validators.email
    }
};
